import React, { PureComponent } from "react";

class Header extends PureComponent {
  render() {
    return (
      <div>
        <h1 className="f1">RoboFriends</h1>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js